export interface Creative {
  isci: string;
  count: number;
  live: boolean;
  campaign_source: string;
}

export interface Placement {
  network: string;
  platform: string;
  count: number;
  iscis: Creative[];
  // The /check_creatives lambda returns null for placements with no ad server.
  adServer: string | null;
}

export const PlacementStatus = {
  RED: 'red',
  YELLOW: 'yellow',
  GREEN: 'green'
} as const;
export type PlacementStatusType = (typeof PlacementStatus)[keyof typeof PlacementStatus];

// Human-readable label for each status, used in the header dot tooltip and summary line.
export const STATUS_LABEL: Record<PlacementStatusType, string> = {
  [PlacementStatus.RED]: 'Issues',
  [PlacementStatus.YELLOW]: 'Minor',
  [PlacementStatus.GREEN]: 'All live'
};
